import { Application } from '@hotwired/stimulus'
import { setupErrorHandling } from '@/lib/stimulus/errorHandlers'

const application = Application.start();

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

setupErrorHandling(application, {
  sentryDsn: import.meta.env.SENTRY_JS_DSN
})

export { application }
